// extracted by mini-css-extract-plugin
export default {"container":"CodeWrite_container__sO+qo","codewrite":"CodeWrite_codewrite__QcldG","light":"CodeWrite_light__vK5KO","floating_text":"CodeWrite_floating_text__VfPWh"};